import React from 'react';
import { TIPOS_NOTA } from '../../utils/cotizacionHelpers';

/**
 * Panel de notas de la cotización con CRUD.
 *
 * @param {Object} props
 * @param {Array} props.notas - Lista de notas
 * @param {boolean} props.loading - Estado de carga
 * @param {boolean} props.isEditable - Si la cotización es editable (estado borrador)
 * @param {Function} props.onCreate - Handler crear nota
 * @param {Function} props.onEdit - Handler editar nota
 * @param {Function} props.onDelete - Handler eliminar nota
 * @returns {JSX.Element}
 */
function CotizacionNotas({
  notas, loading, isEditable, onCreate, onEdit, onDelete
}) {
  return (
    <div className="card">
      <div className="display-flex justify-between align-center margin-bottom-md">
        <h2><i className="fas fa-clipboard-list"></i> Notas de la Cotización</h2>
        {isEditable && (
          <button className="btn btn-primary" onClick={onCreate}>
            <i className="fas fa-plus"></i> Agregar Nota
          </button>
        )}
      </div>

      {loading ? (
        <div className="text-center text-muted">
          <i className="fas fa-spinner fa-spin"></i> Cargando notas...
        </div>
      ) : notas.length === 0 ? (
        <div className="empty-state">
          <i className="fas fa-clipboard-list"></i>
          <p>Sin notas en esta cotización</p>
          {isEditable && <button className="btn btn-primary" onClick={onCreate}>Agregar Primera Nota</button>}
        </div>
      ) : (
        <ul className="nota-list">
          {notas.map(nota => (
            <li key={nota.id} className="nota-item">
              <span className={`badge ${TIPOS_NOTA[nota.tipo]?.badge || 'badge-secondary'}`}>
                {TIPOS_NOTA[nota.tipo]?.label || nota.tipo}
              </span>
              <span className="nota-contenido">{nota.contenido}</span>
              {isEditable && (
                <div className="table-action-buttons">
                  <button className="btn btn-table-action btn-ghost-primary" onClick={() => onEdit(nota)} title="Editar">
                    <i className="fas fa-edit"></i>
                  </button>
                  <button className="btn btn-table-action btn-ghost-danger" onClick={() => onDelete(nota)} title="Eliminar">
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default CotizacionNotas;
